import { render, staticRenderFns } from "./MainHeaderTitleOnly.vue?vue&type=template&id=5cebbe26&scoped=true&lang=pug&"
import script from "./MainHeaderTitleOnly.vue?vue&type=script&lang=js&"
export * from "./MainHeaderTitleOnly.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cebbe26",
  null
  
)

export default component.exports